import React, { useEffect, useRef, useState } from "react";
import exhaust from "../../../../../assets/image/category/exhaust.webp";
import { FaLongArrowAltRight } from "@react-icons/all-files/fa/FaLongArrowAltRight";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import engine from "../../../../../assets/image/services/engine.webp";
import exhaust4 from "../../../../../assets/image/services/exhaust4.webp";
import lossofpower from "../../../../../assets/image/services/lossofpower.webp";
import lowmilage from "../../../../../assets/image/services/lowmilage.webp";
import { Link } from "react-router-dom";
import check from "../../../../../assets/image/check.png";
import overlay from "../../../../../assets/image/overlay.jpg";
import MyButton from "../../utils/Button/MyButton";

export default function Exhaust() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <>
      <div className="overflow-hidden">
        {/* Vancouver Auto Parts Exhaust Services*/}

        <div className="text-black  lg:w-full md:w-full ">
          {/* Image Column (5/12 on large) */}
          <div className="lg:col-span-5 md:col-span-1 relative w-full ">
            <img
              className="lg:h-[30rem]  relative md:w-full md:h-[23rem] h-[20rem] lg:max-w-full object-cover "
              src={exhaust}
              alt="exhaust"
            />
            <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/70 to-transparent"></div>
            <div className="absolute inset-0 lg:mb-14 mb-10 flex items-center justify-center text-white text-center">
              <h3
                className={`text-white  font-bold text-center lg:text-6xl md:text-4xl text-2xl
             transition-all duration-[4000ms] ease-in-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
              >
                Exhaust Services at VAP
              </h3>
            </div>
            <div
              className={`absolute inset-0 lg:mt-20 mt-16 flex items-center justify-center text-white text-center
               transition-all duration-[900ms]  delay-1000 ease-out transform 
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
                <MyButton
                  text=" Expert Exhaust Services "
                  className="bg-orange-500 text-white  py-[12px] rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 shadow-md"
                />
              </Link>
            </div>
          </div>

          {/* Content Column (7/12 on large) */}
          <div className="lg:col-span-7 md:col-span-1 text-center  my-[2.2rem] lg:mx-[8.6rem] md:mx-[3rem]  px-2">
            <div className="">
              <p className="mb-3 mt-3 text-center text-3xl  text-gray-700  font-bold">
                Is your car sounding louder than usual?
              </p>
              <p className="mb-3 text-xl lg:block  text-gray-700 md:block hidden lg:font-normal">
                It might be time for an exhaust system check. Your car’s exhaust
                system plays a crucial role in its overall performance and
                environmental impact. From the exhaust manifold to the tailpipe,
                each component is designed to reduce harmful emissions, maintain
                engine efficiency, and ensure a quiet ride.
              </p>
              <p className="mb-3 text-xl  text-gray-700 lg:font-normal">
                When these parts fail, you might experience more than just a
                noisy drive could see a drop in fuel efficiency, increased
                emissions, or even hazardous exhaust leaks. If you're searching
                for high-quality automotive parts for exhaust repairs, our
                Vancouver Auto Parts online store offers you durable and
                performance-tested solutions to keep your vehicle running
                smoothly.
              </p>

              {/* <p className="mb-3 text-lg lg:font-bold">
                Warning Signs Your Exhaust System Needs Attention:
              </p>
              <ul className="text-xl ps-1">
                {[
                  "Excessive engine noise",
                  "Gas smell inside the car",
                  "Decreased fuel efficiency",
                  "Loss of power when accelerating",
                  "Unusual burning smells near the engine"
                ].map((item, index) => (
                  <li key={index} className="hover:text-blue-900 flex items-center mb-2">
                    <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                      <FaCheck className="text-white p-0.5" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul> */}
              <div
                className={`
           transition-all duration-[950ms] delay-[2500ms] ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
              >
                <Link to="/contact-us">
                  {/* <button className="p-2 rounded text-white bg-orange-500 cursor-pointer flex items-center">
                    Get Exhaust Services in Vancouver Today!
                    <FaArrowRight className="ml-2" />
                  </button> */}
                  <MyButton
                    text="Get Exhaust Services  Today!"
                    className="mx-auto transform transition-transform duration-500 hover:scale-105"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#EFF6FF] ">
          <div className="lg:py-[30px] md:py-[20px] py-[15px] text-center container">
            <h1 className="text-blue-900 font-bold text-[2.23rem] md:text-[2.6rem] lg:text-[3rem]    text-center mb-3">
              Our Exhaust Services
            </h1>
            <p className="mb-3 lg:font-normal  lg:px-[9%] md:px-[13px] text-[1.4rem]">
              Your vehicle’s exhaust system is responsible for reducing
              emissions , ensuring quiet, efficient operation. When a part
              fails, it impacts your vehicle’s performance, fuel efficiency
              <span className="lg:block md:block hidden">
                Our skilled technicians provide expert service for all exhaust
                system components, using high-quality automotive parts sourced
                from trusted auto parts in Canada
              </span>
            </p>

            <div className="flex justtify-center items-center lg:px-[5%] py-3  sm:px-2 ">
              <div className="text-black text-center  h-[100%]  ">
                {/* first */}
                <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] lg:my-[4%] md:my-[4%] my-0 justify-between   dark:bg-gray-800 dark:border-gray-700">
                  <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                    <img
                      src={lossofpower}
                      alt=""
                      className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[93%] h-[17rem]  w-full object-cover  "
                    />
                  </div>

                  <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                    <p className="lg:text-[2.6rem] text-3xl  ">
                      <b>
                        No Compromise On{" "}
                        <span className="text-[#2772AD]">Parts </span>
                      </b>
                    </p>
                    <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                      Using the right parts means better reliability, smoother
                      operation, and fewer future repairs. We choose only
                      durable OEM and performance-grade aftermarket parts that
                      meet or exceed factory standards. This ensures your engine
                      runs quietly and efficiently, giving you peace of mind on
                      every drive—whether it’s a quick errand or a long trip.
                      <div className="font-bold mt-2  ">
                        {" "}
                        <Link
                          to="/contact-us"
                          className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                        >
                          Get in touch <span>&#x27A1;</span>
                        </Link>
                      </div>
                    </p>
                  </div>
                </div>
                {/* second */}
                <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] lg:my-[6%] my-[4%] justify-between   ">
                  <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[97%] w-[100%]">
                    <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                      <b>
                        Don’t Block{" "}
                        <span className="text-[#2772AD]">Performance</span>
                      </b>
                    </p>

                    <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                      A worn or clogged catalytic converter can choke your
                      engine’s performance and lower fuel efficiency. Left
                      unchecked, it may trigger check engine lights, fail
                      emissions tests, or lead to overheating. Routine
                      inspections can catch these issues early—saving you from
                      unexpected repairs, and reduced overall vehicle
                      reliability.
                      <div className="font-bold mt-2  ">
                        {" "}
                        <Link
                          to="/contact-us"
                          className="border-b-2 border-blue-600 hover:opacity-70"
                        >
                          Get in touch <span>&#x27A1;</span>
                        </Link>
                      </div>
                    </p>
                  </div>
                  <div className="lg:w-[50%] md:w-[95%] lg:mb-0 mb-2 flex justify-end">
                    <img
                      src={lowmilage}
                      alt=""
                      className="rounded-[4%]   lg:w-[31.5rem] lg:h-[22rem] md:h-[93%] h-[17rem] object-fill"
                    />
                  </div>
                </div>
                {/* third */}
                <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between   dark:bg-gray-800 dark:border-gray-700">
                  <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                    <img
                      src={exhaust4}
                      alt=""
                      className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[23rem] h-[17rem] w-full object-fill  "
                    />
                  </div>

                  <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                    <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                      <b>
                        Exhaust Needs{" "}
                        <span className="text-[#2772AD]">Support</span>
                      </b>
                    </p>

                    <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                      Loose hangers and worn-out mounts might seem minor, but
                      they place extra stress on exhaust joints. Over time, this
                      can cause rattling, leaks, or even complete pipe
                      separation while driving. Ensuring all fittings are tight
                      and secure keeps your exhaust stable, reduces repair risk,
                      and protects surrounding components from damage.
                      <div className="font-bold mt-2  ">
                        {" "}
                        <Link
                          to="/contact-us"
                          className="border-b-2 border-blue-600 hover:opacity-70"
                        >
                          Get in touch <span>&#x27A1;</span>
                        </Link>
                      </div>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <p className="mb-3 lg:font-normal lg:mx-8 lg:px-24 md:px-4  text-xl">
              Vehicle exhaust is toxic, and the last thing that anyone needs is
              an exhaust leak finding its way into the cabin of your car.
              Sometimes these leaks are not obvious, and a check of the exhaust
              system is an important aspect of regular maintenance.
            </p>
            <p className="lg:mb-6 lg:font-normal lg:block md:block hidden lg:mx-7 lg:px-24 md:px-4 text-xl">
              Don’t wait for exhaust issues to get worse. Keep your ride quiet,
              your engine efficient, and your emissions low. Call us now or
              visit our shop for a professional inspection!
            </p>
          </div>
        </div>
        <div
          className="bg-gray-50 bg-cover lg:h-[60vh] h-[40vh]   bg-center relative text-white"
          style={{ backgroundImage: `url(${overlay})` }}
        >
          <div className="bg-black bg-opacity-50 px-4 py-[50px] flex flex-col items-center absolute justify-center min-h-full min-w-full text-center ">
            <p className="font-bold text-xl md:text-2xl lg:text-3xl my-3">
              Drive Quieter, Cleaner, and Safer – Book Your Exhaust Service
              Today!
            </p>
            {/* <p className="mb-6 text-white text-lg md:text-xl max-w-4xl">
              Vancouver Auto Parts is the name you can trust to service your
              exhaust professionally and have your emissions and carbon
              footprint low.
            </p> */}
            <Link to="/contact-us">
              {/* <button className="bg-orange-500 text-white px-6 py-3 rounded-full text-xl font-bold hover:bg-orange-600 transition">
                Drive in for a FREE exhaust check!
              </button> */}
              <MyButton
                text="Drive in for a FREE exhaust check!"
                className=" px-6 py-[9.5px] transform transition-transform duration-500 hover:scale-105"
              />
            </Link>
          </div>
        </div>
      </div>
      <style>{`
      .tick-list {
        list-style: none;
        padding: 0;
      }
      
      .tick-list li {
        position: relative;
        padding-left: 24px;
      }
      
      .tick-list li::before {
        content: "✔"; 
        color: green;
        font-weight: bold;
        position: absolute;
        left: 0;
      }
      `}</style>
    </>
  );
}
